const pdpAdjustments = (element, callback) => {
    const maxWaitTime = 4000;
    const interval = 90;
    let elapsedTime = 0;

    const waitingInterval = setInterval(() => {
        const selector = document.querySelector(element);
        if (selector) {
            callback();
            clearInterval(waitingInterval);
        } else {
            elapsedTime += interval;
            if (elapsedTime >= maxWaitTime) {
                clearInterval(waitingInterval);
            }
        }
    }, interval);
};

pdpAdjustments(".avis-swatch-option", () => {
    const grindTypeSelector = document.querySelector(".avis-style-type-swatch");

    if (grindTypeSelector) {
        const grindTypeTitle = document.createElement("p");
        grindTypeTitle.classList.add("grind-type-title");
        grindTypeTitle.innerHTML = `Select your grind type`;

        if (!document.querySelector(".grind-type-title")) {
            grindTypeSelector.before(grindTypeTitle);
        }

        if (grindTypeSelector.querySelector(".avis-option-values").children) {

            const grindTypes = [
                {
                    name: "Beans",
                    description: "Whole coffee beans, perfect for grinding fresh at home to your preferred coarseness level.",
                    icon: "beans",
                    width: "30",
                    height: "30"
                },
                {
                    name: "Press",
                    description: "Coarse grind ideal for French Press, creating a rich, full-bodied coffee experience.",
                    icon: "press",
                    width: "30",
                    height: "36"
                },
                {
                    name: "Drip",
                    description: "Medium grind suited for flat-bottom drip coffee makers, ensuring a smooth and consistent brew.",
                    icon: "drip",
                    width: "30",
                    height: "22.7"
                },
                {
                    name: "Cone",
                    description: "Medium-fine grind for cone-shaped filters, perfect for a balanced, flavorful pour-over coffee.",
                    icon: "cone",
                    width: "28",
                    height: "30"
                },
                {
                    name: "Espresso",
                    description: "Fine grind for espresso machines, creating a rich, bold, and concentrated shot.",
                    icon: "espresso",
                    width: "36",
                    height: "36"
                },
                {
                    name: "Extra Fine",
                    description: "Powdery grind for Armenian coffee, delivering a bold, intense, and traditional brew.",
                    icon: "extra-fine",
                    width: "28",
                    height: "30"
                }
            ];

            const Beans = grindTypes[0];
            const Press = grindTypes[1];
            const Drip = grindTypes[2];
            const Cone = grindTypes[3];
            const Espresso = grindTypes[4];
            const ExtraFine = grindTypes[5];

            const seeAllDescriptionsButton = document.createElement("button");
            seeAllDescriptionsButton.classList.add("see-all-descriptions-button");
            seeAllDescriptionsButton.innerHTML = `
                <svg width="17" height="16">
                    <use xlink:href="#exclamation">
                </svg>
                <span> I want to know all the ways I can make my coffee </span>
            `;

            if (!document.querySelector(".see-all-descriptions-button")) {
                grindTypeSelector.after(seeAllDescriptionsButton);
                seeAllDescriptionsButton.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openModal();
                });
            }

            document.addEventListener("click", (e) => {
                const modal = document.querySelector(".grind-types-modal-cont");

                if (modal && modal.classList.contains("grind-modal-active")) {
                    if (e.target.matches(".close-modal-button") || !e.target.closest(".grind-types-modal")) {
                        closeModal();
                    }
                }
            });

            function openModal() {
                const modalCont = document.querySelector(".grind-types-modal-cont");
                if (modalCont) {
                    modalCont.classList.add("grind-modal-active");
                    document.body.style.overflow = "hidden";
                    document.body.style.touchAction = "none";
                }
            }

            function closeModal() {
                const modalCont = document.querySelector(".grind-types-modal-cont");
                if (modalCont) {
                    modalCont.classList.remove("grind-modal-active");
                    document.body.style.overflow = "";
                    document.body.style.touchAction = "";
                }
            }

            const grindTypesModal = document.createElement("div");
            grindTypesModal.classList.add("grind-types-modal-cont");
            grindTypesModal.innerHTML = `
                <div class="grind-types-modal">
                    <button class="close-modal-button">
                        <svg width="16" height="16">
                            <use xlink:href="#close">
                        </svg>
                    </button>
                    <p> How we prepare each Grind type for you: </p>
                    <div class="grind-types">
                        ${grindTypes.map(grindType => {
                return `
                                <div class="grind-type">
                                    <div class="grind-type-icon">
                                        <svg width="${grindType.width}" height="${grindType.height}">
                                            <use xlink:href="#${grindType.icon}">
                                        </svg>
                                        <p> ${grindType.name} </p>
                                    </div>
                                    <div class="grind-type-info">
                                        <p> ${grindType.description} </p>
                                    </div>
                                </div>
                            `;
            }).join("")}
                    </div> 
                </div>
            `;

            if (!document.querySelector(".grind-types-modal")) {
                document.body.appendChild(grindTypesModal);
            }

            const grindTypeDescription = document.createElement("div");
            grindTypeDescription.classList.add("grind-type-description");

            if (!document.querySelector(".grind-type-description")) {
                grindTypeSelector.after(grindTypeDescription);
            }

            function handleGrindType() {
                const grindTypes = grindTypeSelector.querySelectorAll(".avis-option-value-item");
                if (grindTypes) {
                    grindTypes.forEach(type => {
                        const grindTypeTitle = type.querySelector(".apo-tooltip-title");
                        if (!grindTypeTitle) return;
                        
                        const grindType = grindTypeTitle.textContent;

                        if (type.querySelector("input")) {
                            const inputCheckbox = type.querySelector("input");

                            function updateDescription() {
                                if (inputCheckbox.checked) {

                                    switch (grindType) {
                                        case "Beans":
                                            grindTypeDescription.innerHTML = `
                                                <strong> Description: </strong>
                                                <p> ${Beans.description} </p>
                                            `;
                                            break;
                                        case "French Press":
                                            grindTypeDescription.innerHTML = `
                                                <strong> Description: </strong>
                                                <p> ${Press.description} </p>
                                            `;
                                            break;
                                        case "Drip":
                                            grindTypeDescription.innerHTML = `
                                                <strong> Description: </strong>
                                                <p> ${Drip.description} </p>
                                            `;
                                            break;
                                        case "Cone":
                                            grindTypeDescription.innerHTML = `
                                                <strong> Description: </strong>
                                                <p> ${Cone.description} </p>
                                            `;
                                            break;
                                        case "Espresso":
                                            grindTypeDescription.innerHTML = `
                                                <strong> Description: </strong>
                                                <p> ${Espresso.description} </p>
                                            `;
                                            break;
                                        case "Extra Fine":
                                            grindTypeDescription.innerHTML = `
                                                <strong> Description: </strong>
                                                <p> ${ExtraFine.description} </p>
                                            `;
                                            break;

                                    }

                                }
                            }

                            updateDescription();

                            inputCheckbox.addEventListener("change", (e) => {
                                updateDescription();
                            });
                        }
                    });
                }
            }

            handleGrindType();

        }

        const unfilteredSelector = document.querySelectorAll(".avis-swatch-option.avis-style-type-button.avis-design-button");

        const sizeSelector = Array.from(unfilteredSelector).find(selector => {
            return selector.textContent && selector.textContent.includes("Size");
        });


        if (sizeSelector && sizeSelector.textContent.includes("Size") && sizeSelector.textContent.includes("1lb") && sizeSelector.textContent.includes("5lb") && sizeSelector.textContent.includes("4oz")) {
            sizeSelector.classList.add("product-size-selector");

            const sizeSelectorTitle = sizeSelector.querySelector(".avis-option-name");
            if (sizeSelectorTitle) {
                sizeSelectorTitle.classList.add("product-section-title");
            }

            const allSizesButtons = sizeSelector.querySelectorAll(".avis-option-value-item");
            allSizesButtons.forEach((button, index) => {
                button.classList.add("product-size-button");
            });
        }



    }

    function updatePrice() {
        const oneTimePrice = document.querySelector(".rc_widget__price--onetime");
        const subscriptionPrice = document.querySelector(".rc_widget__price--subsave");

        if (oneTimePrice && subscriptionPrice) {
            const clonedPrice = oneTimePrice.cloneNode(true);
            clonedPrice.classList.add("product-cloned-price");
            if (!document.querySelector(".product-cloned-price")) {
                subscriptionPrice.prepend(clonedPrice);
            }
        }
    }

    updatePrice();

    const sizeObserver = new MutationObserver(() => {
        updatePrice();
    });

    const sizeSelector = document.querySelector(".avis-swatch-option.avis-style-type-button.avis-design-button");

    if (sizeSelector) {
        sizeObserver.observe(sizeSelector, {
            childList: true,
            subtree: true,
        });
    }
    
    const rcTemplate = document.querySelector(".rc-template__legacy-radio");
    if (rcTemplate) {
        sizeObserver.observe(rcTemplate, {
            childList: true,
            subtree: true,
        });
    }

    const shippingCalculatorCont = document.querySelector(".simesy-estimated-delivery-date_container");
    const qtySelector = document.querySelector(".quantity-wrapper.me-sm-3");
    const addToCart = document.querySelector(".add-to-cart-btn");
    const newCTAcont = document.createElement("div");
    newCTAcont.classList.add("product-atc-qty--cont");
    newCTAcont.innerHTML = `
      <div class="product-atc-qty">
      </div>
    `;

    if (shippingCalculatorCont && !document.querySelector(".product-atc-qty--cont")) {
        shippingCalculatorCont.before(newCTAcont);
    }
    const newCTA = document.querySelector(".product-atc-qty");

    if (newCTA && qtySelector && addToCart) {
        newCTA.appendChild(qtySelector);
        newCTA.appendChild(addToCart);
    }

    if (window.innerWidth < 620) {
        const productAtcQty = document.querySelector(".product-atc-qty");
        if (productAtcQty) {
            productAtcQty.classList.add("product-atc-hide");
            document.addEventListener("scroll", () => {
                if (window.scrollY > 450) {
                    productAtcQty.classList.remove("product-atc-hide");
                } else {
                    productAtcQty.classList.add("product-atc-hide");
                }
            });
        }
    }

    const priceWrapper = document.querySelector(".price-wrapper.mt-2");
    if (priceWrapper) {
        priceWrapper.remove();
    }
});

pdpAdjustments(".rc-widget.rc_widget .ms-3.mb-2", () => {
    function updateCollapsables() {
        setTimeout(() => {
            if (!document.querySelector(".new-collapsable-cont")) {
                const subsaveOption = document.querySelector(".rc-option__subsave");
                if (!subsaveOption) return;
                
                const subsaveDesc = subsaveOption.querySelector(".ms-3.mb-2");
                if (!subsaveDesc) return;
                
                const discounts = subsaveDesc.children.length > 2 ? true : false;
                subsaveDesc.classList.add("subsave__features");
                const subscriptionAccordion = document.querySelector("custom-accordion");
                if (!subscriptionAccordion) return;
                
                const newAccordion = document.createElement('div');
                newAccordion.innerHTML = `
                <h4> How our subscription works</h4>
                <div>
                    <div class="accordion__container border-bottom border-gray-200 new-open new-collapsable">
                        <div class="accordion__Toggle d-flex p-3 align-items-center pe-2">
                           <h5 style="white-space: pre-wrap;" class="accordion-title mb-0"><p>Discounts</p></h5>
                            <i class="icon-plus ms-auto lh-1 h6 mb-0 d-none"></i>
                            <i class="icon-minus ms-auto lh-1 h6 mb-0"></i>
                        </div>
                        <div class="new-collapsable-cont accordion__block toggle-content new-open" id="faq-sub-9" data-type="content" style="">
                            <div class="new-collapsable-content">
                            </div>
                        </div>
                    </div>
                </div>
            `;
                subscriptionAccordion.prepend(newAccordion);
                const collapsableContent = document.querySelector(".new-collapsable-content");
                if (collapsableContent) {
                    collapsableContent.prepend(subsaveDesc);
                }

                const subsaveFeatures = document.querySelector(".new-collapsable .subsave__features");
                const newCollapsable = document.querySelector(".new-collapsable");
                if (subsaveFeatures && subsaveFeatures.children.length === 0 && newCollapsable) {
                    newCollapsable.style.display = "none";
                }
            }

        }, 0);
    }

    document.addEventListener("mouseup", (e) => {
        const collapsableCont = document.querySelector(".new-collapsable-cont");
        if (!collapsableCont) return;
        
        const collapsableContHeight = collapsableCont.scrollHeight;
        const newCollapsable = document.querySelector(".new-collapsable");
        
        if (e.target.closest("div.accordion__Toggle") && newCollapsable) {
            if (newCollapsable.classList.contains("new-open")) {
                newCollapsable.classList.remove("new-open");
                collapsableCont.classList.remove("new-open");
                const iconPlus = document.querySelector(".new-collapsable .icon-plus");
                const iconMinus = document.querySelector(".new-collapsable .icon-minus");
                if (iconPlus) iconPlus.classList.remove("d-none");
                if (iconMinus) iconMinus.classList.add("d-none");
                collapsableCont.style.height = `${collapsableContHeight}px`;
                setTimeout(() => {
                    collapsableCont.style.height = `0`;
                }, 10);
            } else {
                newCollapsable.classList.add("new-open");
                collapsableCont.classList.add("new-open");
                const iconPlus = document.querySelector(".new-collapsable .icon-plus");
                const iconMinus = document.querySelector(".new-collapsable .icon-minus");
                if (iconPlus) iconPlus.classList.add("d-none");
                if (iconMinus) iconMinus.classList.remove("d-none");
                collapsableCont.style.height = `${collapsableContHeight - 20}px`;
            }
        }
    });

    const collapsableObserver = new MutationObserver(() => {
        updateCollapsables();
    });

    const rcTemplateLegacy = document.querySelector(".rc-template__legacy-radio");
    if (rcTemplateLegacy) {
        collapsableObserver.observe(rcTemplateLegacy, {
            subtree: true,
            attributes: true,
            childList: true,
        });
    }

});

if (window.innerWidth > 800) {
    const coffeeFeatureText = document.querySelector(".coffee-feature-text");
    if (coffeeFeatureText) {
        coffeeFeatureText.textContent = `All coffees are roasted and shipped by 8am PST Monday thru Friday with a roasted-on date.`;
    }
}

document.addEventListener('mouseup', (e) => {
    const rcTemplateLegacyRadio = document.querySelector(".rc-template__legacy-radio");
    if (rcTemplateLegacyRadio) {
        if (e.target.closest(".rc-option__subsave label")) {
            rcTemplateLegacyRadio.classList.add("option__selected");
        } else if (e.target.closest(".rc-option__onetime label")) {
            rcTemplateLegacyRadio.classList.remove("option__selected");
        }
    }
});